import { render } from "./AdditionalProvision.vue?vue&type=template&id=723d9c03&scoped=true"
import script from "./AdditionalProvision.vue?vue&type=script&lang=js"
export * from "./AdditionalProvision.vue?vue&type=script&lang=js"

import "./AdditionalProvision.vue?vue&type=style&index=0&id=723d9c03&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723d9c03"]])

export default __exports__